/**
 * 表示用フォーマッタ。
 *
 * カタログの3つのビュー（タイル・リスト・スライドショー）と詳細モーダルが
 * 同じ値を別々に整形すると必ず表記がずれるので、ここに集約する。
 */

export const formatBytes = (bytes: number | null): string => {
  if (bytes == null) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit += 1
  }
  return `${value.toFixed(value >= 100 || unit === 0 ? 0 : 1)} ${units[unit]}`
}

/**
 * 尺の表示。秒で丸めてから分秒に割る。
 * ミリ秒のまま `%60000` すると 59.6 秒が「0分60秒」になる。
 */
export const formatDuration = (ms: number | null): string => {
  if (ms == null) return '—'
  const total = Math.round(ms / 1000)
  return `${Math.floor(total / 60)}分${total % 60}秒`
}

export const formatDateTime = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleString('ja-JP') : '—'

export const formatDate = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleDateString('ja-JP') : '—'

export const STATUS_LABEL: Record<string, string> = {
  published: '公開中',
  archived: '提供終了',
  processing: '変換中',
  uploading: 'アップロード中',
  draft: '下書き',
  failed: '変換失敗',
}

export const KIND_LABEL: Record<string, string> = {
  video: '動画',
  image: '写真',
}

/**
 * 操作ログ（audit_logs）の action の表示名。
 *
 * DB のトリガが action を増やしてもここが追随するまでは生値のまま表示する
 * （`AUDIT_ACTION_LABEL[a] ?? a` で参照すること）。settings 系の正確な
 * 文字列は DB 実装に依存するので、未知の値でも壊れないことが前提。
 */
export const AUDIT_ACTION_LABEL: Record<string, string> = {
  'user.provisioned': '登録',
  'user.role_changed': 'ロール変更',
  'user.deactivated': '停止',
  'user.reactivated': '再開',
  'user.auth_unlinked': '認証解除',
  'user.org_changed': '組織変更',
  'invitation.created': '招待作成',
  'invitation.accepted': '招待受理',
  'invitation.deleted': '招待取消',
  'license.created': 'ライセンス発行',
  'license.updated': 'ライセンス変更',
  'organization.created': '組織作成',
  'organization.updated': '組織変更',
  'settings.email_updated': 'メール設定変更',
  'settings.watermark_updated': '透かし設定変更',
  'auth.login_link_issued': 'ログインリンク発行',
  'category.created': 'カテゴリ作成',
  'category.updated': 'カテゴリ変更',
  'category.deleted': 'カテゴリ削除',
  'asset_field.created': '項目作成',
  'asset_field.updated': '項目変更',
  'asset_field.deleted': '項目削除',
  'category_field.assigned': '項目の割り当て',
  'category_field.updated': '項目の割り当て変更',
  'category_field.unassigned': '項目の割り当て解除',
}
